import * as React from "react";
import classnames from "classnames";
/* empty css          */
const Chip = ({ className, children, href, onClick }) => {
  return /* @__PURE__ */ React.createElement("a", { href, className: classnames("chip", className), onClick }, children);
};
export {
  Chip
};
//# sourceMappingURL=Chip.js.map
